/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import _ from "underscore";
import util from "../util/util.js";

var SurveySummaryHeaderViewModel = function(params) {
	var self = this;

	var me = ko.observable();
	birdata.me(true).then(me);

	// Set default params
	params = _.defaults(params, {
	});

	var survey = ko.isObservable(params.survey) ? params.survey : ko.observable(params.survey);

	self.surveyID = ko.pureComputed(function() {
		// var survey = ko.unwrap(params.survey);
		// return survey && survey.id;
		// console.log(survey());
		return survey() && survey().id;
	});

	self.showEdit = params.showEdit || ko.pureComputed(function() {
		return survey() && survey().can_update;
	});

	self.showDelete = ko.pureComputed(function() {
		return survey() && survey().can_delete && params.afterDelete;
	});

	self.showContact = ko.pureComputed(function() {
		return survey() && survey().observer_email && me() && me().id !== survey().user_id;
	});

	self.contactMailToURL = function() {
		var body = [
			"Dear " + (survey().observer_name || "<name>") + ",",
			"",
			"I am writing to you in relation to a bird survey recorded by you in Birdata dated " + survey().start_date + ".",
			"",
			"To view the survey details, click here: " + self.shareURL(),
			"",
			"Kind regards"
		].join("\r\n");

		return "mailto:" + encodeURIComponent(survey().observer_email) + "?" + util.encodeParams({
			body: body,
			subject: "Query regarding Birdata survey " + survey().id
		});
	};

	// self.showEdit = params.showEdit || false;
	self.shareURL = ko.pureComputed(function() {
		var url = params.shareURL || (survey() && survey().share_url);
		if(url) {
			url = (window.location.protocol + "//" + window.location.host) + url;
		}
		return url;
	});

	self.showShareMenu = ko.observable(false);

	self.showShareMenu.subscribe(function(show) {
		if(show) {
			// Auto-select link after showing share menu
			setTimeout(function() {
				if(self.showShareMenu()) {
					var element = document.getElementById(self.shareURLElementID);
					element.select();
					element.setSelectionRange(0, 99999);
				}

				// Auto-dismiss on click outside element
				var listener = function(evt) {
					if(util.ancestorSatisfies(evt.target, function(el) { return el.classList.contains("share-menu"); })) {
						return;
					}
					document.removeEventListener('click', listener);
					self.showShareMenu(false);
					return false;
				};

				document.addEventListener('click', listener);
			}, 400);
		}
	});

	self.facebookShareURL = ko.pureComputed(function() {
		return "https://www.facebook.com/sharer/sharer.php?" + util.encodeParams({ u: self.shareURL() });
	});

	self.twitterShareURL = ko.pureComputed(function() {
		return "https://twitter.com/intent/tweet/?" + util.encodeParams({ text: 'Birdata survey', url: self.shareURL() })
	});

	self.emailShareURL = ko.pureComputed(function() {
		return "mailto:?" + util.encodeParams({ subject: 'Birdata survey', body: self.shareURL() })
	});

	self.shareURLElementID = util.uuid();

	self.copyLink = function() {
		var element = document.getElementById(self.shareURLElementID);
		element.select();
		element.setSelectionRange(0, 99999);
		document.execCommand("copy");
	}

	self.handleClose = params.handleClose;

	self.deleteSurvey = function() {
		if(self.deleteInProgress()) {
			return;
		}
		if(confirm("Are you sure you want to delete this survey?")) {
			self.deleteInProgress(true);
			birdata.deleteSurvey(survey().id).then(() => {
				self.afterDelete();
			}).catch((e) => {
				alert("Delete failed");
				throw e;
			}).finally(() => {
				self.deleteInProgress(false);
			});
		}
	}

	self.afterDelete = params.afterDelete || function() {};

	self.deleteInProgress = params.deleteInProgress || ko.observable(false);
};


ko.components.register('survey-summary-header', {
	viewModel: function(params) {
		return new SurveySummaryHeaderViewModel(params);
	},
	template: require('../../templates/survey-summary-header.html')
});

export default SurveySummaryHeaderViewModel;
